module.exports = __webpack_public_path__ + "static/img/07niu.1720486b.gif";